export default __webpack_public_path__ + "static/media/PAYE_Assessment_Template_Form.90f9eb20.xlsx";